import { UseMultipleChartsType } from '@ecosystem/export-utils';
import { useCallback } from 'react';
import { ShareComparisonChartResp } from '@data-visualization/share-comparison-chart/Types';
import { FactRevenue, Option, PageName } from '@utils/pageConfig/Types';
import { ExportChartOptions } from '../Model';
import { useExportApi } from '../UseExportApi';
import { exportCombinedChart } from './ExportCombinedChart';
import { PagesConfig } from '@utils/pageConfig/PagesConfigContext';
import { useGetLoadedProductGroups } from '../UseGetLoadedProductGroups';

export interface ExportCombinedChartOptions extends ExportChartOptions {
  title: string;
  appliedCountry: Option[] | undefined;
  appliedPg: Option[] | undefined;
  data: ShareComparisonChartResp; //Add more necessary types here later for other charts
  timePeriod: string;
  comparisonTimePeriod: string;
  factRevenue: FactRevenue;
  periodType: string;
  showPerformanceWithin: string;
  appliedFiltersText: string;
  selectedKpi: Option;
  chartSubtitle: string;
  pageName: PageName;
  multipleChartsExport?: UseMultipleChartsType;
  volume?: string;
  pagesConfig?: PagesConfig;
}

export function useExportCombinedChart(): {
  download: (options: ExportCombinedChartOptions) => Promise<void>;
} {
  const { exportFile: exportFn } = useExportApi();
  const { loadedProductGroups } = useGetLoadedProductGroups();

  const download = useCallback(
    async (options: ExportCombinedChartOptions) => {
      const {
        exportFormats,
        invokeExport,
        title,
        appliedCountry,
        appliedPg,
        data,
        timePeriod,
        comparisonTimePeriod,
        factRevenue,
        periodType,
        showPerformanceWithin,
        appliedFiltersText,
        selectedKpi,
        pageName,
        multipleChartsExport,
        pagesConfig,
        chartSubtitle,
      } = options;

      await exportCombinedChart({
        exportFn,
        exportFormats,
        invokeExport,
        title,
        appliedCountry,
        appliedPg,
        data,
        timePeriod,
        comparisonTimePeriod,
        factRevenue,
        periodType,
        showPerformanceWithin,
        appliedFiltersText,
        selectedKpi,
        segmentBy: '',
        pageName,
        multipleChartsExport,
        pagesConfig,
        subtitle: chartSubtitle,
        ...loadedProductGroups,
      });
    },
    [loadedProductGroups],
  );

  return {
    download,
  };
}
